/**
 * Transforms a string into slug-format (kebab-case) by
 * replacing spaces with hyphens and changing to lower-case.
 * @param {string} str String to transform.
 * @returns {string} The transformed string.
 */
export const generateSlug = str =>
  str
    .toLowerCase()
    .replace(/'/g, '')
    .replace(/[^\w\d]/g, '-')
    .trim()

/**
 * Replaces a single character with a chosen string (empty by default)
 * at a specified index.
 * @param {string} original The string to perform the replacement on.
 * @param {number} index The position of the character to replace.
 * @param {string} replacement The replacement string.
 * @returns {string}
 */
export const replaceAtIndex = function replaceAtIndex(original, index, replacement = '') {
  try {
    return original.slice(0, index) + replacement + original.slice(index + 1)
  } catch (error) {
    return original
  }
}

/**
 * Find the value appended to the end of a token.
 * Tokens should start and end with double square brackets.
 * Do not include the dot at end of key as this is used
 * to identify the value that follows.
 *
 * Example:
 * tokenList = [ '[[prices.investment.1000]]', '[[prices.year.2018]]' ]
 * key = 'prices.investment'
 * return = 1000
 *
 * @param {string} key The sequence to search for.
 * @return {string} The remaining text after the sequence.
 */
export const getMatchedTokenValue = function getMatchedTokenValue(tokenList, key) {
  try {
    const token = tokenList.find(item => item.includes(key))
    return token
      .replace(/\[\[/g, '')
      .replace(/\]\]/g, '')
      .replace(key, '')
      .replace('.', '')
  } catch (e) {
    return ''
  }
}
